import React, { ReactElement, useCallback } from "react";
import { useAuth0, Auth0Provider, Auth0ContextInterface } from "@auth0/auth0-react";
import { ViEnvVariableNotSetError } from "../models/Errors";
export * from "@auth0/auth0-react";

declare global {
  interface Window {
    Cypress: any;
    auth0Client: Auth0ContextInterface;
  }
}

interface IProps {
  children: ReactElement;
}

const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || "",
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || "",
  audience: process.env.REACT_APP_VICORE_AUTH0_AUDIENCE,
  redirectUri: window.location.origin,
};

if (auth0Config.domain === undefined)
  throw new ViEnvVariableNotSetError("REACT_APP_AUTH0_DOMAIN");
if (auth0Config.clientId === undefined)
  throw new ViEnvVariableNotSetError("REACT_APP_AUTH0_CLIENT_ID");
if (auth0Config.audience === undefined)
  throw new ViEnvVariableNotSetError("REACT_APP_VICORE_AUTH0_AUDIENCE");

if (window.Cypress) {
  window.auth0Client = useAuth0();
}

export const AuthProvider = ({ children }: IProps) => {
  const onRedirectCallback = useCallback((state: any) => {
    if (state.returnTo) {
      window.location = state.returnTo;
    }
  }, []);

  return (
    <Auth0Provider {...{ ...auth0Config, onRedirectCallback }}>{children}</Auth0Provider>
  );
};

export const useAuth = useAuth0;
